import React, { useEffect, useRef, useState } from "react"
import PropTypes from 'prop-types'
import { v4 as uuidv4 } from 'uuid'

import { PhoneApiMakeCall } from "../ExternalApi/PhoneApi"
import { PushApiCallHistoryAddOutboundCall } from "../ExternalApi/PushApi"
import { NowInDateTimeFormat, IsEmptyString } from "./GeneralFunctions"

import CloudCTIPng from '../Assets/CloudCTI.png'

const MakeCall = (props) => {
  const mSecurityToken = localStorage.getItem("securitytoken")

  const [mNumber,SetNumber] = useState(props.Number.replace(/[^0-9$+]/g, ''))

  const GetCallHistoryFromLocalStorage = () => {
    const CallHistoryString = localStorage.getItem("callhistory")
    if (!IsEmptyString(CallHistoryString))
    {
      try { return JSON.parse(CallHistoryString) } catch {}
    }
    return []
  }

  const MakeCall = (aNumber, aName, aApplication, aScripts) => 
  {
      try 
      {  
        //Do the actual makecall
        PhoneApiMakeCall(mSecurityToken, aNumber, false).then((result) => 
        {
          if (result !== null) 
          { 
            console.log("PhoneApiMakeCall error", result) 
          }
          else
          {    
            //Make up a callid
            const CallId = uuidv4()
        
            //Save the call online
            PushApiCallHistoryAddOutboundCall(mSecurityToken, CallId, aNumber, aName, aApplication, aScripts, false)
            
            //Save the call locally in the call history 
            const CallHistory = [...[{ CallId: CallId, Number: aNumber, Name: aName, Application: aApplication, Scripts: aScripts, Incoming: false, DateTime: NowInDateTimeFormat() }],...GetCallHistoryFromLocalStorage()]
            console.log("localStorage.setItem(callhistory)",CallHistory)
            localStorage.setItem("callhistory", JSON.stringify(CallHistory))

            const timeout = setTimeout(() => {
              new BroadcastChannel("cloudctiwebclient2024").postMessage("calllistchanged")
            }, 1000)
          }
        })
      } 
      catch (ex) 
      {    
        console.log("MakeCall failed", ex)
      }
  } 

  useEffect(() => {  
      MakeCall(mNumber, "", "", [])
      import('../autoClose.js');
  }, []);

  return (
    <table className="main" height="100%" width="100%" cellPadding={0}>        
    <tbody>
      <tr height="25" className="topbar"> 
          <td align="center" valign="center">    
            <img src={CloudCTIPng} className="cloudctiicon"/>        
          </td>   
      </tr>
      <tr height="*"> 
          <td width="*" align="center" valign="top">
            Calling number {mNumber}
          </td>
      </tr>
      </tbody>
    </table>
  )
}

MakeCall.propTypes = {
  Number: PropTypes.string
}

export default MakeCall